<template>
  <span data-app>
    <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <md-button
          :disabled="isNotCheckedOut"
          @click="
            itemToEdit = null
            createDialog = true
            keyCreate = keyCreate + 1
          "
          style="float: right;"
          class="md-warning"
        >
          <img
            :src="icons.createButton"
            style="height: 26px; width: 26px; margin-right: 10px;"
          />
          <span style="color: black;">{{
            $t('entitiesList.newEntities')
          }}</span>
        </md-button>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>list_alt</md-icon>
            </div>
            <h4 class="title inlineTitle">
              {{ $t('drawer.workspace.subitems.entities') }}
            </h4>
            <md-button
              :disabled="isNotCheckedOut"
              class="rightJustify md-simple md-github"
            >
              <md-icon>publish</md-icon>
              {{ $t('intentsList.import') }}
            </md-button>
          </md-card-header>
          <md-card-content>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              :md-selected-value.sync="selected"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="pages">{{ $t('entitiesList.perPage') }}</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>

                <md-field>
                  <md-input
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px;"
                    :placeholder="$t('entitiesList.search') + '...'"
                    :value="searchQuery"
                    @input="updateSearch"
                  ></md-input>
                </md-field>
              </md-table-toolbar>

              <md-table-toolbar
                slot="md-table-alternate-header"
                slot-scope="{ count }"
                style="position: relative;"
              >
                <div class="backgroundRed md-toolbar">
                  <div class="md-toolbar-section-start">
                    {{ count }}
                    {{
                      count > 1
                        ? $t('entitiesList.itemsSelected')
                        : $t('entitiesList.itemSelected')
                    }}
                  </div>

                  <div class="md-toolbar-section-end">
                    <md-button
                      :disabled="isNotCheckedOut"
                      class="md-simple md-github"
                    >
                      <md-icon>get_app</md-icon>
                      {{ $t('entitiesList.export') }}
                    </md-button>
                    <md-button
                      :disabled="isNotCheckedOut"
                      class="md-simple md-github"
                      @click="deleteSelected"
                    >
                      <md-icon>delete</md-icon>
                      {{ $t('entitiesList.delete') }}
                    </md-button>
                    <md-button
                      class="md-simple md-github"
                      @click="clearSelection"
                      >{{ $t('entitiesList.cancel') }}</md-button
                    >
                  </div>
                </div>
              </md-table-toolbar>

              <md-table-row
                slot="md-table-row"
                slot-scope="{ item }"
                md-selectable="multiple"
                @click="editItem(item)"
                style="cursor: pointer;"
              >
                <md-table-cell
                  :md-label="$t('entitiesList.entityName')"
                  md-sort-by="entity"
                  style="color: #4caf50;"
                >
                  @{{ item.entity }}
                </md-table-cell>
                <md-table-cell :md-label="$t('entitiesList.value')">
                  {{ listItemValues(item) }}
                </md-table-cell>
                <md-table-cell
                  md-label="Fuzzy Matching"
                >
                  <span style="margin-right: 35px;"
                    >{{item.fuzzy_match || 'false'}}</span
                  >
                </md-table-cell>
                <!-- <md-table-cell
                  :md-label="$t('entitiesList.modified')"
                  md-sort-by="modified"
                >
                  <span style="margin-right: 35px;"
                    >3 {{ $t('entitiesList.daysAgo') }}</span
                  >
                </md-table-cell> -->
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                {{
                  $t('entitiesList.showingItems', {
                    from: from + 1,
                    to: to,
                    total: total,
                  })
                }}
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <v-dialog v-model="createDialog" max-width="700px" :scrollable="true">
      <CreateEntityDialog
        @save="save"
        @close-create-dialog="createDialog = false"
      />
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      fullscreen
      hide-overlay
      persistent
      max-width="700px"
      :scrollable="true"
    >
      <EditEntityDialog
        v-if="editDialog"
        :item="itemToEdit"
        @save="save"
        @close-edit-dialog="editDialog = false"
      />
    </v-dialog>
  </span>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import Fuse from 'fuse.js'
import CreateEntityDialog from '@/components/CreateEntityDialog.vue'
import EditEntityDialog from '@/components/EditEntityDialog.vue'
import debounce from 'lodash/debounce'
import Swal from 'sweetalert2'

export default {
  model: {
    prop: 'entities',
    event: 'update'
  },
  props: {
    entities: { required: true, type: Array },
    viewingMode: { required: true, type: Boolean }
  },
  components: {
    Pagination,
    CreateEntityDialog,
    EditEntityDialog
  },
  computed: {
    userEntities () {
      return this.entities.filter((e) => !e.entity.startsWith('sys-'))
    },
    searchedData () {
      return this.searchQuery !== ''
        ? this.fuseSearch.search(this.searchQuery)
        : this.userEntities
    },
    queriedData () {
      return this.searchedData?.slice(this.from, this.to) || []
    },
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.searchedData?.length || this.entities.length
    },
    isNotCheckedOut () {
      return (
        this.$store.state.snapshots.appliedSnapshot._source.status !==
          'checkedout' || this.viewingMode === true
      )
    }
  },
  data () {
    return {
      editItemIndex: '',
      currentSort: 'entity',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['entity', 'values'],
      fuseSearch: null,
      icons: {
        createButton: require('../../public/img/plus.png'),
        pencil: require('../../public/img/pencil-icon.png')
      },
      selected: [],
      createDialog: false,
      keyCreate: 0,
      editDialog: false,
      itemToEdit: '',
      keyEdit: 0
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.searchQuery = value
    }, 366),
    clearSelection () {
      this.selected = []
    },
    customSort (value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === 'desc') {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    async deleteSelected () {
      const checkedOutSnap = this.$store.getters['snapshots/checkedOutByUser']
      const entities = this.entities.filter(
        (entity) => !this.selected.includes(entity)
      )
      await this.$store.dispatch('snapshots/save', {
        id: checkedOutSnap._id,
        data: {
          entities
        }
      })
      // console.log(`deleted entities`, response)
      this.updateFuse(entities)
      this.clearSelection()
      this.$emit('update', entities)
    },
    updateFuse (entities) {
      this.fuseSearch = new Fuse(entities, {
        keys: ['entity', 'values'],
        threshold: 0.3
      })
    },
    goTo (path) {
      this.$router.push(path)
    },
    toEntitiesPage () {
      this.$router.push('/entities-edit')
    },
    editItem (item) {
      this.itemToEdit = item
      if (!item.values) item.values = []
      this.editItemIndex = this.entities.findIndex(entity => entity.entity === item.entity)
      this.editDialog = true
      // console.log(item)
    },
    listItemValues (item) {
      return item?.values?.map((val) => val.value)?.join(', ') || ''
    },
    async save (entityData) {
      const checkedOutSnap = this.$store.getters['snapshots/checkedOutByUser']
      if (this.itemToEdit) {
        this.$set(this.entities, this.editItemIndex, entityData)
        this.itemToEdit = null
      } else {
        const hasEntity = this.entities.some(currentEntity => currentEntity.entity === entityData.entity)
        if (!hasEntity) {
          this.entities.push(entityData)
        } else {
          Swal.fire({
            icon: 'error',
            title: this.$t('entitites.entityError'),
            text: this.$t('entitites.thereAlreadyEntityRegistered'),
            showConfirmButton: true
          })
        }
      }

      await this.$store.dispatch('snapshots/save', {
        id: checkedOutSnap._id,
        data: {
          entities: this.entities
        }
      })

      // console.log(`saved entity!`, response)
      this.updateFuse(this.entities)
      this.editDialog = false
    }
  },
  mounted () {
    this.updateFuse(this.entities)
  }
}
</script>

<style lang="css">
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
.md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .paginated-table table>tbody>tr>td {
    max-width: unset !important;
} */
</style>
